<template>
    <el-card>
        <h4>{{title}}</h4>
        <div style="position:relative;">
            <dv-scroll-ranking-board :config="config" style="width:98%;height:300px;color:black"/>
        </div>
    </el-card>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: '排行榜'
            },
            config: {
                type: Object,
                default: null
            },
        },
        data() {
            return {

            }
        }
    }
</script>

<style lang="scss">
    .dv-scroll-ranking-board .ranking-column .inside-column {
        background-color: #07a2a4;
    }
    .dv-scroll-ranking-board .ranking-info .rank {
        width: 40px;
        color: #d87a80;
    }
    .dv-scroll-ranking-board .ranking-column {
        border-bottom: 1px solid #2ec7c9;
        margin-top: 5px;
    }
    .box-card-component {
        .el-card__header {
            padding: 0px !important;
        }
    }
</style>
<style lang="scss" scoped>

    .box-card-component {
        .box-card-header {
            position: relative;
            height: 220px;

            img {
                width: 100%;
                height: 100%;
                transition: all 0.2s linear;

                &:hover {
                    transform: scale(1.1, 1.1);
                    filter: contrast(130%);
                }
            }
        }

        .progress-item {
            margin-bottom: 20px;
            font-size: 14px;
        }
    }
</style>
